import { DataLoadURL } from '../model/dataload-url';

export const LegalDocument = {
  Get: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'document/legalDocument'
  } as DataLoadURL
};
